/* eslint-disable standard/no-callback-literal */ /* eslint-disable standard/no-callback-literal */
<template>
  <div class="add-contract">
    <a-form layout="vertical" :form="form" @submit="handleSubmit">
      <a-form-item>
        <div class="add-title" style="display: flex; align-items: center">
          <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="toList" />
          <h1 style="margin: 0">合同/{{ contractTitle }}</h1>
          <!-- <a-icon
            @click="$router.go(-1)"
            type="left-circle"
            style="font-size: 20px; margin-left: 10px; margin-top: 8px"
          /> -->
        </div>
      </a-form-item>
      <!-- :wrapper-col="{ span: 6, offset: 0 }" -->
      <div class="input-box">
        <h1>核心信息</h1>
        <div class="contract-code">
          <a-form-item label="合同编号" style="width: 360px">
            <a-input
              :disabled="true"
              v-decorator="['contractCode', { rules: [{ required: false, message: '请输入合同编号' }] }]"
              placeholder="请输入合同编号"
            />
            <!-- <a-button
              @click="generateCode"
              style="margin-left: 30px"
              type="primary"
              class="el_button el-button--primary"
              >点击生成
            </a-button> -->
          </a-form-item>
          <a-form-item label="合同类型" style="width: 260px; margin-left: 200px">
            <a-select
              @change="getContractType"
              style="width: 150px"
              v-decorator="['contractType', { rules: [{ required: true, message: '请选择合同类型' }] }]"
              placeholder="请选择合同类型"
            >
              <a-select-option v-for="item in rent_sale_type" :key="item.dictValue" :value="item.dictValue">
                {{ item.dictLabel }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="choice-houses" v-show="isSelectContractType">
          <h1>房源</h1>
          <!-- <p @click="isLookList = true">选择房源</p> -->
          <a-button
            style="margin: 0 0 20px 0"
            type="primary"
            @click="isLookList = true"
            class="el_button el-button--primary"
          >选择房源
          </a-button>
          <div v-if="records && records.length > 0" class="houses-list">
            <!--  -->
            <house-view-list v-if="iscontractYype" :records="records" />
            <houseListSellVue v-if="!iscontractYype" :records="records" />
            <!-- <houseListSellVue v-if="true" :records="records" /> -->
          </div>
          <h1 v-else>请选择房源</h1>
          <a-form-model>
            <div v-for="(item, index) in hoursInfoVoList" :key="item.id">
              <div v-if="item.lessorsType === '2'" class="tenant-box house-form-box">
                <a-form-model-item>
                  <p class="lable-box">
                    <span>*</span> <span>{{ item.lable }}</span>
                  </p>
                  <a-input placeholder="请输入联系人" v-model="item.lessorsName" />
                </a-form-model-item>
                <a-form-model-item class="idCard-box">
                  <p class="lable-box"><span>*</span> <span>身份证/港澳台通行证/统一社会编码</span></p>
                  <a-input

                    v-model="item.lessorCardNo"
                    @change="(e) => validateCard(item, item.lessorCardNo)"
                    placeholder="身份证/港澳台通行证/统一社会编码"
                  />
                  <p class="tips" v-show="item.msgtips">{{ item.msgtips }}</p>
                </a-form-model-item>
                <a-form-model-item>
                  <p class="lable-box 0000"><span>*</span> <span>电话</span></p>
                  <a-button
                    :disabled="getDisabled"
                    v-if="item.lessorsPhone && item.lable !== '业主' && !isEditPermission"
                  >{{ item.lessorsPhone.substr(0, 3) + '****' + item.lessorsPhone.substr(7, 11) }}</a-button
                  >
                  <a-input
                    v-else
                    v-model="item.lessorsPhone"
                    :maxLength="11"
                    placeholder="请输入电话"
                    @change="validateMobileFn(item.lessorsPhone, index)"
                  />
                  <p class="tips">{{ item.msgtipsPhone }}</p>
                </a-form-model-item>

                <a-form-model-item v-if="item.lessorsType === '1'">
                  <p class="lable-box"><span>房源地址</span></p>
                  <a-input placeholder="请输入房源地址" v-model="item.houseAddress" />
                </a-form-model-item>
                <a-form-model-item v-if="item.lessorsType === '1'">
                  <p class="lable-box"><span>产权地址</span></p>
                  <a-input placeholder="请输入产权地址" v-model="item.propertyAddress" />
                </a-form-model-item>
              </div>
              <div v-if="item.lessorsType === '2'">
                <a-form-model-item label="添加业主或二房东">
                  <a-select style="width: 120px" v-model="lessorsType_1_3">
                    <a-select-option value="1"> 业主 </a-select-option>
                    <a-select-option value="3"> 二房东 </a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>

              <div v-if="item.lessorsType === lessorsType_1_3" class="tenant-box house-form-box">
                <a-form-model-item>
                  <p class="lable-box">
                    <span>*</span> <span>{{ item.lable }}</span>
                  </p>
                  <a-input placeholder="请输入联系人" v-model="item.lessorsName" />
                </a-form-model-item>
                <a-form-model-item>
                  <p class="lable-box"><span>*</span> <span>身份证/港澳台通行证/统一社会编码</span></p>
                  <a-input

                    @change="(e) => validateCard(item, item.lessorCardNo)"
                    v-model="item.lessorCardNo"
                    placeholder="身份证/港澳台通行证/统一社会编码"
                  />
                  <p class="tips" v-show="item.msgtips">{{ item.msgtips }}</p>
                </a-form-model-item>
                <a-form-model-item>
                  <p class="lable-box"><span>*</span> <span>电话</span></p>
                  <a-button :disabled="getDisabled" v-if="item.lessorsPhone && !isEditPermission">{{
                    item.lessorsPhone.substr(0, 3) + '****' + item.lessorsPhone.substr(7, 11)
                  }}</a-button>
                  <!-- <a-input
                    v-else
                    v-model="item.lessorsPhone"
                    :maxLength="11"
                    placeholder="请输入电话"
                    @change="validateMobileFn(item.lessorsPhone, index)"
                  /> -->
                  <a-input
                    v-else
                    v-model="item_lessorsPhone"
                    :maxLength="11"
                    placeholder="请输入电话"
                    @change="validateMobileFn(item_lessorsPhone, index)"
                  />
                  <p class="tips">{{ item.msgtipsPhone }}</p>
                </a-form-model-item>

                <a-form-model-item v-if="item.lessorsType === '1'">
                  <p class="lable-box"><span>房源地址</span></p>
                  <a-input :disabled="getDisabled" placeholder="请输入房源地址" v-model="item.houseAddress" />
                </a-form-model-item>
                <a-form-model-item v-if="item.lessorsType === '1'">
                  <p class="lable-box"><span>产权地址</span></p>
                  <a-input placeholder="请输入产权地址" v-model="item.propertyAddress" />
                </a-form-model-item>
              </div>
            </div>
          </a-form-model>
        </div>
        <div class="choice-houses" v-show="isSelectContractType">
          <h1>客源</h1>
          <a-button
            style="margin: 0 0 20px 0"
            @click="showModal('istourist')"
            type="primary"
            class="el_button el-button--primary"
          >选择客源
          </a-button>
          <div v-if="touristData" class="houses-list">
            <tenantView
              :shopsTypeList="shopsTypeList"
              :investmentTypelist="investmentTypelist"
              :touristData="touristData"
              :iscontractYype="iscontractYype"
            />
            <!-- <houseListVue :records="records"></houseListVue> -->
          </div>
          <h1 v-else>请选择客源信息</h1>
          <div class="tenant-box">
            <a-form-item label="客人姓名">
              <a-input
                v-decorator="['lesseeName', { rules: [{ required: true, message: '请输入客人姓名' }] }]"
                placeholder="请输入客人姓名"
              />
            </a-form-item>
            <a-form-item label="身份证/港澳台通行证/统一社会编码">
              <a-input

                v-decorator="['lesseeCardNo', validatorRules.checkIdCard]"
                placeholder="请输入"
              />
            </a-form-item>
            <a-form-item label="品牌">
              <a-input
                v-decorator="['lesseeBrandName', { rules: [{ required: true, message: '请输入品牌' }] }]"
                placeholder="请输入品牌"
              />
            </a-form-item>
            <a-form-item label="客人电话">
              <template v-if="!showLesseePhone || isEditPermission">
                <a-input
                  placeholder="请输入电话"
                  :maxLength="11"
                  v-decorator="['lesseePhone', validatorRules.lesseePhone]"
                />
              </template>

              <!-- <a-input disabled="true" v-decorator="['lesseePhone', validatorRules.lesseePhone]" /> -->
              <a-button :disabled="getDisabled" v-if="showLesseePhone && !isEditPermission">{{
                showLesseePhone.substr(0, 3) + '****' + showLesseePhone.substr(7, 11)
              }}</a-button>
            </a-form-item>
          </div>
        </div>
        <!--  v-if="iscontractYype"  -->
        <div v-if="iscontractYype" class="transaction-box">
          <h1>交易</h1>
          <div class="transaction-msg">
            <a-form-item label="成交租金">
              <a-input
                :maxLength="10"
                placeholder="请输入成交租金"
                v-decorator="['rentExpense', validatorRules.rentExpenseFn]"
                suffix="元/月"
              />
              <!--  -->
              <!-- v-decorator="['lessorComm', { rules: [{ required: true, message: '请输入房东佣金' }] }]" -->
            </a-form-item>
            <a-form-item label="免租期">
              <a-input
                suffix="天"
                type="number"
                v-decorator="['rentfreePeriod', { rules: [{ required: true, message: '请输入免租期' }] }]"
                placeholder="请输入免租期"
              />
            </a-form-item>
            <a-form-item label="转让费">
              <a-input
                suffix="万元"
                :maxLength="10"
                v-decorator="['transferFee', validatorRules.transferFee]"
                placeholder="请输入转让费"
              />
              <!-- v-decorator="['transferFee', { rules: [{ required: true,message: '请输入转让费' }] }]" -->
            </a-form-item>
            <a-form-item label="首次交租日期">
              <!-- style="width: 200px" -->
              <a-date-picker
                v-decorator="['firstPayDate', { rules: [{ required: true, message: '请选择首次交租日期' }] }]"
              />
            </a-form-item>
          </div>
          <div class="transaction-msg payment-box">
            <a-form-item label="支付方式" style="width: 200px">
              <a-input
                prefix="付"
                suffix="月"
                placeholder="请输入支付方式"
                v-decorator="[
                  'paymentMethod',
                  { rules: [{ required: true, message: '请输入支付方式' }] },
                ]"
              />
            </a-form-item>
            <a-form-item label="押金" style="width: 200px">
              <a-input
                placeholder="请输入押金金额"
                suffix="元"
                v-decorator="['pledge', { rules: [{ required: true, message: '请输入押金金额' },{ validator: handleNumber }] }]"
              >
                <!-- <a-select slot="addonAfter" default-value=".com" style="width: 80px">
                  <a-select-option value=".com">

                  </a-select-option>
                </a-select> -->
              </a-input>
            </a-form-item>
            <a-form-item label="是否包含免租期">
              <a-select
                v-decorator="['isRentfreePeriod', { rules: [{ required: true, message: '请选择是否包含短租期' }] }]"
                placeholder="是否包含免租期"
              >
                <a-select-option value="Y"> 是</a-select-option>
                <a-select-option value="N"> 否</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="提前交租时间">
              <a-input
                suffix="天"
                type="number"
                placeholder="请输入提前交租时间"
                v-decorator="['daysAdvance', { rules: [{ required: true, message: '请输入提前交租时间' }] }]"
              />
            </a-form-item>
            <a-form-item label="递增">
              <a-input
                style="width: 100%"
                placeholder="请输入递增"
                v-decorator="['growthPattern', { rules: [{ required: true, message: '请输入递增' }] }]"
              />
            </a-form-item>
          </div>
          <div class="transaction-msg">
            <a-form-item label="起租日期">
              <a-date-picker
                style="width: 200px"
                v-decorator="['leaseStartTime', { rules: [{ required: true, message: '请选择起租日期' }] }]"
              />
            </a-form-item>
            <a-form-item label="截止日期">
              <!-- <a-input v-decorator="['note', { rules: [{ required: true, message: 'Please input your note!' }] }]" /> -->
              <a-date-picker
                style="width: 200px"
                v-decorator="['leaseEndTime', { rules: [{ required: true, message: '请选择截止日期' }] }]"
              />
            </a-form-item>
            <a-form-item label="签约人">
              <a-input disabled :value="signName" placeholder="签约人"></a-input>
            </a-form-item>
            <a-form-item label="签约日期">
              <a-date-picker
                :disabled="getDisabled"
                style="width: 200px"
                v-decorator="['signDate', { rules: [{ required: true, message: '请选择签约日期' }] }]"
              />
            </a-form-item>
          </div>
          <div class="transaction-msg payment-box 2">
            <a-form-item label="房东佣金">
              <a-input
                placeholder="请输入房东佣金"
                v-decorator="[
                  'lessorComm',
                  { rules: [{ required: true, message: '请输入房东佣金' }, { validator: handleNumber }] },
                ]"
                suffix="元"
              />
            </a-form-item>
            <a-form-item label="租客佣金">
              <a-input
                placeholder="请输入租客佣金"
                suffix="元"
                v-decorator="[
                  'lesseeComm',
                  { rules: [{ required: true, message: '请输入租客佣金' }, { validator: handleNumber }] },
                ]"
              />
            </a-form-item>
            <a-form-item label="房源方信息费">
              <a-input
                suffix="元"
                placeholder="请输入房源方信息费"
                v-decorator="[
                  'houstInfoFee',
                  { rules: [{ required: true, message: '请输入房源方信息费' }, { validator: handleNumber }] },
                ]"
              />
            </a-form-item>
            <a-form-item label="客源方信息费">
              <a-input
                suffix="元"
                placeholder="请输入客源方信息费"
                v-decorator="[
                  'customerInfoFee',
                  { rules: [{ required: true, message: '请输入客源方信息费' }, { validator: handleNumber }] },
                ]"
              />
            </a-form-item>
          </div>
        </div>
        <div v-if="!iscontractYype" class="transaction-box">
          <h1>交易（售）</h1>
          <div class="transaction-msg">
            <a-form-item label="成交金额">
              <a-input
                placeholder="请输入成交金额"
                v-decorator="['transactionAmount', validatorRules.rentExpenseFnSall]"
                suffix="元"
              />
            </a-form-item>
            <a-form-item label="付款方式">
              <a-select
                @change="getPaymentType"
                v-decorator="['paymentType', { rulessorCommles: [{ required: true, message: '请选择付款方式' }] }]"
                placeholder="请选择付款方式"
              >
                <a-select-option v-for="item in paymentTypeList" :key="item.dictSort" :value="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="isLoan" label="首付">
              <a-input suffix="元" v-decorator="['transferFee', validatorRules.transferFee]" placeholder="请输入首付" />
              <!-- v-decorator="['transferFee', { rules: [{ required: true,message: '请输入转让费' }] }]" -->
            </a-form-item>
          </div>
          <div class="transaction-msg payment-box">
            <a-form-item label="签约人">
              <a-input disabled :value="signName" placeholder="签约人"></a-input>
            </a-form-item>
            <a-form-item label="签约日期">
              <a-date-picker
                :disabled="getDisabled"
                style="width: 200px"
                v-decorator="['signDate', { rules: [{ required: true, message: '请选择签约日期' }] }]"
              />
            </a-form-item>
            <a-form-item label="房源佣金">
              <a-input
                suffix="元"
                v-decorator="[
                  'lessorComm',
                  { rules: [{ required: true, message: '请输入房源佣金' }, { validator: handleNumber }] },
                ]"
                placeholder="请输入房源佣金"
              />
            </a-form-item>
            <a-form-item label="客户佣金">
              <a-input
                suffix="元"
                v-decorator="[
                  'lesseeComm',
                  { rules: [{ required: true, message: '请输入客户佣金' }, { validator: handleNumber }] },
                ]"
                placeholder="请输入客户佣金"
              />
            </a-form-item>
          </div>
          <div class="transaction-msg payment-box">
            <a-form-item label="房源方信息费">
              <a-input
                suffix="元"
                placeholder="请输入房源方信息费"
                v-decorator="[
                  'houstInfoFee',
                  { rules: [{ required: true, message: '请输入房源方信息费' }, { validator: handleNumber }] },
                ]"
              />
            </a-form-item>
            <a-form-item label="客源方信息费">
              <a-input
                suffix="元"
                placeholder="请输入客源方信息费"
                v-decorator="[
                  'customerInfoFee',
                  { rules: [{ required: true, message: '请输入客源方信息费' }, { validator: handleNumber }] },
                ]"
              />
            </a-form-item>
          </div>
        </div>

        <div class="textarea">
          <a-form-item>
            <a-textarea v-decorator="['contractsRemark']" placeholder="请输入备注信息" :rows="8" />
          </a-form-item>
        </div>
        <div class="enclosure">
          <h1>附件 (支持pdf、png、jpeg)</h1>
          <div class="contract-upload">
            <p><span style="color: #f15a5a">*</span>租赁合同</p>
            <FileUpload
              :defaultFileList="contractFileList"
              :multiple="true"
              @changeList="(val) => changeList(val, 'contract')"
              :count="9"
              :showUploadList="true"
              type="image"
              :value="contractUrl"
              @input="uploadImgurl"
              @ossId="uploadImgOssId"
            />

            <p><span style="color: #f15a5a">*</span>产权证&产权查档</p>
            <FileUpload
              :defaultFileList="propertyFileList"
              :multiple="true"
              @changeList="(val) => changeList(val, 'property')"
              :count="9"
              :showUploadList="true"
              type="image"
              :value="propertyUrl"
              @input="uploadPropertyUrl"
              @ossId="uploadPropertyUrlOssId"
            />
          </div>
          <div class="contract-upload">
            <p><span style="color: #f15a5a">*</span>甲方身份证(请上传正反面)</p>
            <ManyFileUpload :f-list="LessorCardList" type="image" @fileListUrlFn="ManyLessorCard" :fileListLength="2" />
            <!-- <FileUpload type="image" :value="lesseeCardUrl" @input="uploadLessorCardUrl" @ossId="uploadLessorCardUrlOssId"/> -->
            <p><span style="color: #f15a5a">*</span>乙方身份证(请上传正反面)</p>
            <ManyFileUpload
              type="image"
              :f-list="lesseeCardList"
              @fileListUrlFn="ManyLesseeCardUrl"
              :fileListLength="2"
            />
            <!-- <FileUpload type="image" :value="lessorCardUrl" @input="uploadLesseeCardUrl" @ossId="uploadLesseeCardUrlOssId" /> -->
          </div>
          <div class="contract-upload">
            <p>其他</p>
            <FileUpload type="image" :value="otherUrl" @input="uploadOtherUrl" @ossId="uploadOtherUrlOssId" />
          </div>
        </div>
      </div>
      <div style="text-align: center; margin: 40px 0">
        <a-form-item>
          <a-button html-type="submit" type="primary" class="el_button el-button--primary" :loading="submitLoading">
            提交
          </a-button>
        </a-form-item>
      </div>
    </a-form>
    <!--选择租房源弹窗  -->
    <look-list
      :isLookList="isLookList"
      :houseStatus="houseStatus"
      @closeModal="isLookList = $event"
      @dataList="getListData"
      v-if="iscontractYype"
    ></look-list>
    <!-- 选择售房源弹窗 -->
    <LookSallList
      v-if="!iscontractYype"
      :isLookList="isLookList"
      :houseStatus="houseStatus"
      @closeModal="isLookList = $event"
      @dataList="getListData"
    />
    <!--选择客源弹窗  -->
    <a-modal
      title="选择客源"
      width="38%"
      :visible="touristSourcevisible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :maskClosable="false"
      :footer="null"
      centered
    >
      <div class="choice-housesdilog">
        <div class="roundSearch-box">
          <a-input
            @change="searchTourist"
            @keyup.enter.native="searchTourist"
            placeholder="智能搜索"
            v-model="housesSearch"
          >
            <a-icon slot="prefix" type="search" />
          </a-input>
        </div>
        <a-spin :spinning="spinning">
          <div class="tourist-item" @click="getTouristMsg(item)" v-for="item in touristUserList" :key="item.id">
            <div class="user-name">
              <h1>{{ item.lesseeName ? item.lesseeName.substring(0, 1) : '-' }}</h1>
              <div class="user-msg">
                <div>
                  <h1>{{ item.lesseeName }}</h1>
                </div>
                <p>{{ item.lessorsPhone }}</p>
                <p>编号{{ item.lesseeCode }}</p>
              </div>
            </div>
            <p>维护人：{{ item.accendantName }}</p>
          </div>
        </a-spin>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="(total) => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import houseViewList from '@/components/houseList/houseList.vue'
import houseListSellVue from '@/components/houseList/houseSellList.vue'
import tenantView from '@/components/Tenant/index.vue'
import LookList from '@/components/modal/LookList.vue'
import LookSallList from '@/components/modal/sellLookList.vue'
import FileUpload from '@/components/FileUpload/index.vue'
import ManyFileUpload from '@/components/ManyFileUpload/index.vue'
// import UploadFileListCmp from '@/components/UploadFileListCmp/index'
import { listUser } from '@/api/system/user'
import moment from 'moment'
import touristApi from '@/api/system/tourist/tourist.js'
import sellTouristApi from '@/api/system/tourist/sell_tourist.js'
import { addContract, contractsInfo, editContractsInfo } from '@/api/system/contract'
// import { validateIdCard } from '@/utils/validate'
import beforeRouteLeaveMixin from '@/mixin/beforeRouteLeave'
import closeTagMixin from '@/mixin/closeTags'
import { getCurrentDate } from '@/utils/date'
const OSS_BASE_URL = process.env.VUE_APP_OSS_URL

export default {
  name: 'ContractAdd',
  components: {
    tenantView,
    LookList,
    LookSallList,
    FileUpload,
    houseViewList,
    ManyFileUpload,
    houseListSellVue
    // UploadFileListCmp
  },
  mixins: [beforeRouteLeaveMixin, closeTagMixin],
  data () {
    return {
      showLesseePhone: '', // 客人电话
      item_lessorsPhone: '',
      lessorsType_1_3: '1', // 1业主 3二房东
      lesseePhone: '', // 租客电话号码（仅用于展示）
      rent_sale_type: [],
      LessorCardList: [],
      lesseeCardList: [],
      houseId: '',
      newhoused: '',
      signName: '',

      lessorsPhoneArr: [],
      hoursInfoVoList: [],
      validatorRules: {
        lessorCardNo: { rules: [{ required: true, validator: this.validateIdCard }] },
        lesseeCardNo: { rules: [{ required: true, validator: this.validateCard }] },
        checkIdCard: { rules: [{ required: true, validator: this.checkIdCard }] },
        lessorPhone: { rules: [{ required: true, validator: this.validateMobile }] },
        lesseePhone: { rules: [{ required: true, validator: this.validateMobile }] },
        transferFee: { rules: [{ required: true, validator: this.transferFeeFn }] },
        rentExpenseFn: { rules: [{ required: true, validator: this.rentExpenseFn }] },
        rentExpenseFnSall: { rules: [{ required: true, validator: this.rentExpenseFnSall }] }
      },
      id: '', // 编辑时需要的id 新增不需要
      records: [],
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { customerInfoFee: '' }),
      loading: false,
      imageUrl: '',
      contractForm: {
        contractsRemark: '' // 备注
      },
      submitLoading: false,
      //  选择房源弹框
      isLookList: false,
      houseStatus: '1',
      ModalText: 'Content of the modal',
      confirmLoading: false,
      housesSearch: '',
      touristSourcevisible: false, // 客源租客弹窗
      signUserList: [], // 签约人列表
      housesResourcesList: [], // 房源列表
      touristUserList: [], // 客源列表
      touristData: undefined, // 客源
      lesseeId: '', // 承租人id
      demandId: '', // 客源需求id
      contractUrl: '', // 合同文件url
      // 出租房身份证文件URL甲方
      lesseeCardUrl: '',
      // 其他
      otherUrl: '', // 产权文件URL
      // lessorCardUrl: '', // 乙方url，
      propertyUrl: '', // 产权文件
      queryParam: {
        pageNum: 1,
        pageSize: 4
      },
      total: 0,
      spinning: false,
      contractTitle: '新建合同',
      detailsId: '',
      contractUrlOssid: '', // 合同文件url
      // 出租房身份证文件URL甲方
      lesseeCardUrlOssid: [],
      otherUrlOssid: '', // 其他
      lessorCardUrlOssid: [], // 乙方url，
      propertyUrlOssid: '', // 产权文件
      iscontractYype: false, // 合同类型---
      paymentTypeList: [],
      isLoan: false,
      shopsTypeList: [],
      investmentTypelist: [],
      houseCode: '', // 房源编号
      shopName: '', // 店铺名称
      isSelectContractType: '', // 是否选择了合同类型
      contractFileList: [], // 合同文件附件
      propertyFileList: [] // 产权附件
    }
  },
  computed: {
    // 判断是否禁用，签约日期
    getDisabled () {
      const userInfo = this.$getters.userInfo
      const permissions = userInfo && userInfo.data.permissions

      // console.log(permissions, 'permissions')
      if (this.$route.query.id) {
        if (permissions.includes('system:contractsInfo:editFinancial')) {
          return false
        }

        return true
      }
      return true
    },
    isEditPermission () {
      const userInfo = this.$getters.userInfo
      const permissions = userInfo && userInfo.data.permissions
      if (permissions.includes('system:contractsInfo:editFinancial')) {
        return true
      }

      return false
    },
    // 获取当天
    getCurrentDay () {
      return this.$moment(getCurrentDate())
    }
  },
  mounted () {
    if (!this.$route.query.id) {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          signDate: this.$moment(getCurrentDate()).format('YYYY-MM-DD')
        })
      })
    }
  },

  methods: {
    init () {
      if (this.$route.query.id) {
        // console.log(this.$route.query.id, 'this.$route.query.id')
        // 编辑合同
        this.detailsId = this.$route.query.id
        this.contractTitle = '编辑合同'

        this.getContractsInfo(this.detailsId)
      }
      this.getSignUserList()
      // 字典列表
      this.getDicts('payment_type2').then((response) => {
        this.paymentTypeList = response.data
      })
      // 合同类型
      this.getDicts('rent_sale_type').then((response) => {
        this.rent_sale_type = response.data
        // this.form.setFieldsValue({ contractType: '2' })
      })
    },
    moment,

    // 多选文件
    changeList (values, type) {
      // console.log(values,'9999999')
      const fileList = values.map((el) => {
        if (el.response && el.response.data) {
          return el.response.data.ossId
        }
        if (el.ossId) {
          return el.ossId
        }
      })
      if (type === 'contract') {
        this.contractUrlOssid = fileList.join(',')
      } else if (type === 'property') {
        this.propertyUrlOssid = fileList.join(',')
      }
    },
    // 验证输入为数字
    handleNumber (rule, value, callback) {
      console.log(rule, '000')
      const reg = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/
      if (value && Number(value) + '' == 'NaN') {
        callback('请输入正确的金额')
        return
      }
      if (value && !reg.test(value)) {
        callback('输入金额保留两位小数')
        return
      }
      callback()
      // console.log(e,key,'kye',data)
    },
    // 提交
    handleSubmit (e) {
      e.preventDefault()
      console.log(e, '000000', this.form)
      this.form.validateFields((err, values) => {
        console.log(err, values, 'errvauss')
        if (!err) {
          // Pledge 表示押几个月租金
          // 起租日期
          values.paymentMethod = 'Y' + values.pledge + 'F' + values.paymentMethod
          const params = values
          // console.log(params,'1111')
          if (this.records.length === 0) {
            this.$message.error('请选择房源')
            return
          }
          if (!this.lesseeId) {
            this.$message.error('请选择租客')
            return
          }
          // 判断房源信息是否填写完整
          // this.hoursInfoVoList.forEach(item => {
          //   if (!item.lessorsName) {
          //     this.$message.error('请填写联系人')
          //     return
          //   }
          //   if (!item.lessorsPhone) {
          //     this.$message.error('请填写联系人电话')
          //     return
          //   }
          //   if (!item.lessorCardNo) {
          //     this.$message.error('请填写身份证号')
          //     return
          //   }
          //   console.log('不要删除')
          // })
          // console.log(this.hoursInfoVoList, 'hoursInfoVoList')
          const listFlag = this.hoursInfoVoList.filter((item) => {
            return item.lessorsType === '2' || item.lessorsType === this.lessorsType_1_3
          })
          // console.log(listFlag, 'listFlag')

          listFlag.forEach((item) => {
            const flag = item.lessorsType === this.lessorsType_1_3
            if (flag) {
              item.lessorsPhone = this.item_lessorsPhone || item.lessorsPhone
            }
          })
          // console.log(listFlag, 'listFlag_forEach')
          const isPossession = listFlag.map((item) => {
            if (!item.lessorsName || !item.lessorsPhone || !item.lessorCardNo) {
              //  this.$message.error('请填写转让方姓名')
              return false
            }
          })
          // console.log(isPossession, 'isPossession')
          if (isPossession.includes(false)) {
            this.$message.error('请填写完整房源人信息')
            return
          }
          // 动态绑定联系人电话校验
          // 动态绑定身份证正则
          this.isphone = false
          this.isIdCard = false
          this.hoursInfoVoList.find((item) => {
            if (item.msgtipsPhone) {
              this.isphone = true
            }
            if (item.msgtips) {
              this.isIdCard = true
            }
          })
          if (this.isphone) {
            this.$message.error('请输入正确的联系电话')
            return
          }
          if (this.isIdCard) {
            this.$message.error('请输入正确身份证号')
            return
          }
          // 判断电话是否重复
          // this.getLessorsPhone()
          // for (var i = 0; i < this.lessorsPhoneArr.length; i++) {
          //   if (this.lessorsPhoneArr.indexOf(this.lessorsPhoneArr[i]) !== i) {
          //     this.$message.error('联系人电话不能重复')
          //     return
          //   }
          // }
          if (!this.contractUrlOssid) {
            this.$message.error('请上传租赁合同')
            return
          }
          if (!this.propertyUrlOssid) {
            this.$message.error('请上传产权文件')
            return
          }
          // console.log(this.lesseeCardUrlOssid.length, 'this.lesseeCardUrlOssid')
          if (this.lesseeCardUrlOssid.length !== 2) {
            this.$message.error('请上传甲方身份证信息')
            return
          }
          // console.log(this.lessorCardUrlOssid.length, 'this.lesseeCardUrlOssid')
          if (this.lessorCardUrlOssid.length !== 2) {
            this.$message.error('请上传乙方身份证信息')
            return
          }

          // 出租人id
          params.lessorId = this.records[0].lessorIds
          params.lesseeId = this.lesseeId
          params.lesseeRequirementId = this.demandId
          params.houseId = this.records[0].id
          params.contractUrl = this.contractUrlOssid
          params.lesseeCardUrl = this.lesseeCardUrlOssid.toString()
          // console.log(this.lessorCardUrlOssid, 'lessorCardUrlOssid')
          params.lessorCardUrl = this.lessorCardUrlOssid.toString()
          params.otherUrl = this.otherUrlOssid
          params.propertyUrl = this.propertyUrlOssid
          params.firstPayDate = moment(params.firstPayDate).format('YYYY-MM-DD')
          params.leaseStartTime = moment(params.leaseStartTime).format('YYYY-MM-DD')
          params.leaseEndTime = moment(params.leaseEndTime).format('YYYY-MM-DD')
          params.signDate = moment(params.signDate).format('YYYY-MM-DD')
          params.houseCode = this.houseCode
          // console.log('this.shopName', this.shopName)
          params.shopName = this.shopName
          params.signId = this.accendantId // 售
          params.lesseePhone = values.lesseePhone || this.showLesseePhone
          // console.log(params, 'params',this.showLesseePhone)

          if (this.id) {
            // 编辑
            params.id = this.id
            if (this.newhoused) {
              if (this.houseId !== this.newhoused) {
                this.newHous()
              }
            }

            params.contractLessorRelationBoList = this.hoursInfoVoList.filter((item) => {
              return item.lessorsType === '2' || item.lessorsType === this.lessorsType_1_3
            })

            this.getEditContract(params)
            return
          }
          // 新增
          this.newHous()
          params.contractLessorRelationBoList = this.hoursInfoVoList.filter((item) => {
            return item.lessorsType === '2' || item.lessorsType === this.lessorsType_1_3
          })
          // console.log(params,'000000')
          this.getAddContract(params)
        } else {
          console.log(err, 'err')
        }
      })
    },
    // // 检测是否是数字
    // validateNumber(){

    // },
    // 动态绑定身份证号码正则
    validateIdCardFn (value, index) {
      const reg = /^(\d{18,18}|\d{15,15}|\d{17,17}X|x)$/
      this.hoursInfoVoList.forEach((item, i) => {
        if (index === i) {
          if (!value || !reg.test(value)) {
            item.msgtips = '您的身份证号码格式不正确!'
          } else {
            item.msgtips = ''
          }
        }
      })
    },

    getPaymentType (e) {
      if (e === '2') {
        this.isLoan = true
      } else {
        this.isLoan = false
      }
    },
    // 获取合同类型
    getContractType (e) {
      // this.houseStatus = e
      console.log(e)
      if (e == '2') {
        this.iscontractYype = false
      } else {
        this.iscontractYype = true
      }
      this.records = []
      this.hoursInfoVoList = []
      this.newhoused = ''
      // 重置租客售客
      this.touristData = undefined

      this.isSelectContractType = e
      this.$nextTick(() => {
        this.form.setFieldsValue({
          lesseeBrandName: undefined,
          lesseeName: undefined,
          lesseePhone: undefined,
          lesseeCardNo: '',
          signDate: this.$moment(getCurrentDate()).format('YYYY-MM-DD')
        })
      })

      // console.log(this.form['contractType'],'00000',e)
    },
    // 动态绑定电话号码正则
    validateMobileFn (value, index) {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      this.hoursInfoVoList.forEach((item, i) => {
        if (index === i) {
          if (!value || !reg.test(value)) {
            item.msgtipsPhone = '您的手机号码格式不正确!'
          } else {
            item.msgtipsPhone = ''
          }
        }
      })
    },
    // 仅检测18位数
    validateCard (rule, value, callback) {
      if (!value) {
        callback('请输入身份证号')
      }
      // if (value && value.length != 18) {
      //   if (callback) {
      //     callback('请输入18位的身份证格式')
      //   }
      //   rule.msgtips = '请输入18位的身份证格式'
      //   console.log(rule, 'rule')
      //   return
      // }
      rule.msgtips = ''
    },
    checkIdCard (rule, value, callback) {
      if (!value) {
        callback('编码必须存在')
      }
      callback()
    },
    // 身份证号的正则
    validateIdCard (rule, value, callback) {
      if (!value) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入证件号')
      }
      // if (value.length < 18) {
      //   callback('请输入18位的身份证格式')
      //   return
      // }
      //
      // if (!value ) {
      //   callback()
      // } else {
      //   // eslint-disable-next-line standard/no-callback-literal
      //   callback('您的身份证号码格式不正确!')
      // }
      callback()
    },
    // 手机号正则
    validateMobile (rule, value, callback) {
      if (!value) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入手机号')
      }
      if (!value || new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/).test(value)) {
        callback()
      } else {
        // eslint-disable-next-line standard/no-callback-literal
        callback('您的手机号码格式不正确!')
      }
    },
    // 判断万元正则
    transferFeeFn (rule, value, callback) {
      const reg = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/
      if (!value) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入转让费')
      }
      if (!reg.test(value)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入正确的转让费')
      } else {
        callback()
      }
    },
    rentExpenseFn (rule, value, callback) {
      const reg = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/
      if (!value) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入成交租金')
      }
      if (!reg.test(value)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('成交租金只能为数字并保留两位小数')
      } else {
        callback()
      }
    },
    // 新增合同=>新增房源
    newHous () {
      this.hoursInfoVoList.forEach((item) => {
        item.lessorId = item.id
        delete item.id
      })
    },

    rentExpenseFnSall (rule, value, callback) {
      const reg = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/
      if (!value) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入成交金额')
      }
      if (!reg.test(value)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('成交金额只能为数字并保留两位小数')
      } else {
        callback()
      }
    },
    // 新增合同=>新增房源
    newHous () {
      this.hoursInfoVoList.forEach((item) => {
        item.lessorId = item.id
        delete item.id
      })
    },
    // 判断电话业主电话重复
    getLessorsPhone () {
      const lessorsPhoneArr = []
      this.hoursInfoVoList.forEach((item) => {
        if (item.lessorsPhone) {
          lessorsPhoneArr.push(item.lessorsPhone)
        }
      })
      this.lessorsPhoneArr = lessorsPhoneArr
    },
    // 获取子组件选择的对象
    // getListData (data) {
    //   this.records = [data]
    //   this.houseCode = data.houseCode
    //   this.shopName = data.shopName
    //   this.newhoused = this.records[0].id
    //   this.hoursInfoVoList = this.records[0].lessorInfoVoList
    //   this.records[0].lessorIds = data.lessorIds
    //   this.records[0].lessorIds = this.records[0].lessorIds.split(',')
    //   this.records[0].lessorIds = parseFloat(this.records[0].lessorIds[0])
    //   const arr = []
    //   this.hoursInfoVoList.forEach((item) => {
    //     item.lessorId = item.id
    //     arr.push(item.lessorsType)
    //     if (item.lessorsType === '1') {
    //       item.lable = '业主'
    //     }
    //     if (!this.propertyUrlOssid) {
    //       this.$message.error('请上传产权文件')
    //       return
    //     }
    //     console.log(this.lesseeCardUrlOssid.length, 'this.lesseeCardUrlOssid')
    //     if (this.lesseeCardUrlOssid.length !== 2) {
    //       this.$message.error('请上传甲方身份证信息')
    //       return
    //     }
    //     if (item.lessorsType === '4') {
    //       item.lable = '代理人'
    //     }
    //   })
    //   if (!arr.includes('1')) {
    //     this.hoursInfoVoList.push({
    //       id: undefined,
    //       lable: '业主',
    //       lessorsName: undefined,
    //       lessorsPhone: undefined,
    //       lessorsType: '1'
    //     })
    //   }
    //   if (this.iscontractYype) {
    //     if (!arr.includes('3')) {
    //       this.hoursInfoVoList.push({
    //         lable: '二房东',
    //         lessorsName: undefined,
    //         lessorsPhone: undefined,
    //         lessorsType: '3'
    //       })
    //     }
    //   }
    //   this.deleteItem(this.hoursInfoVoList)
    // },
    deleteItem (list) {
      var isFirst = true
      list.forEach((item, index) => {
        if (item.lessorsType === '1') {
          if (!isFirst) {
            list.splice(index, 1)
          } else {
            isFirst = false
          }
        }
        if (this.iscontractYype) {
          if (item.lessorsType === '4') {
            // 不展示代理人
            this.hoursInfoVoList.splice(index, 1)
          }
        }
        // 新增
        this.newHous()
        params.contractLessorRelationBoList = this.hoursInfoVoList
        this.getAddContract(params)
      })
    },

    // 获取子组件选择的对象
    getListData (data) {
      this.records = [data]
      console.log('====records=====================', this.records)
      this.newhoused = this.records[0].id
      this.shopName = data.shopName
      this.houseCode = data.houseCode
      this.hoursInfoVoList = this.records[0].lessorInfoVoList
      this.records[0].lessorIds = data.lessorIds
      this.records[0].lessorIds = this.records[0].lessorIds.split(',')
      this.records[0].lessorIds = parseFloat(this.records[0].lessorIds[0])
      const arr = []
      this.hoursInfoVoList.forEach((item) => {
        item.lessorId = item.id
        arr.push(item.lessorsType)
        if (item.lessorsType === '1') {
          item.lable = '业主'
          // item.houseAddress = data.districtName + data.businessDistrictName + data.streetName
        }
        if (item.lessorsType === '2') {
          item.lable = '转让方'
        }
        if (item.lessorsType === '3') {
          item.lable = '二房东'
        }
        item.houseAddress = data.districtName + data.businessDistrictName + data.streetName
      })
      console.log(arr, 'arr')
      if (!arr.includes('1')) {
        this.hoursInfoVoList.push({
          id: undefined,
          lable: '业主',
          lessorsName: undefined,
          lessorsPhone: undefined,
          lessorsType: '1',
          houseAddress: data.districtName + data.businessDistrictName + data.streetName
        })
      }
      if (!arr.includes('3')) {
        this.hoursInfoVoList.push({
          lable: '二房东',
          lessorsName: undefined,
          lessorsPhone: undefined,
          lessorsType: '3'
        })
      }
    },
    searchTourist () {
      if (this.iscontractYype) {
        this.getTouristSourceList()
      } else {
        this.getTouristSallSourceList()
      }
    },
    // 选择房源弹窗 客源
    showModal () {
      this.touristSourcevisible = true
      this.housesSearch = ''
      if (this.iscontractYype) {
        this.getTouristSourceList()
      } else {
        this.getTouristSallSourceList()
      }
    },
    handleOk (e) {
      this.ModalText = 'The modal will be closed after two seconds'
      this.confirmLoading = true
      setTimeout(() => {
        this.visible = false
        this.confirmLoading = false
      }, 2000)
    },
    handleCancel () {
      this.touristSourcevisible = false
    },
    // 获取签约人下拉框
    getSignUserList () {
      listUser().then((res) => {
        const { code, rows } = res
        if (code === 200) {
          this.signUserList = rows
        }
      })
    },
    // 查询租客客源需求列表
    getTouristSourceList () {
      if (this.housesSearch) {
        this.queryParam.pageNum = 1
      }
      this.spinning = true
      touristApi
        .lesseeRequirementList({
          pageNum: this.queryParam.pageNum,
          pageSize: this.queryParam.pageSize,
          requirementResourceType: 2,
          requirementSort: 1,
          sortType: 'ASC',
          search: this.housesSearch,
          requirementStatus: 1
        })
        .then((res) => {
          this.spinning = false
          if (res.code === 200) {
            this.touristUserList = res.data.records
            this.total = res.data.total
          }
        })
    },
    // 查询售客客源列表
    getTouristSallSourceList () {
      if (this.housesSearch) {
        this.queryParam.pageNum = 1
      }
      this.spinning = true
      sellTouristApi
        .lesseeRequirementList({
          pageNum: this.queryParam.pageNum,
          pageSize: this.queryParam.pageSize,
          requirementResourceType: 2,
          requirementSort: 1,
          sortType: 'ASC',
          search: this.housesSearch,
          requirementStatus: 1
        })
        .then((res) => {
          this.spinning = false
          if (res.code === 200) {
            this.touristUserList = res.data.records
            this.total = res.data.total
          }
        })
    },
    // 客源分页
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getTouristSourceList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getTouristSourceList()
    },
    // 获取租客信息
    getTouristMsg (item) {
      console.log(item, 'itemxinxi')
      this.form.setFieldsValue({
        lesseeBrandName: item.brandName,
        lesseeName: item.lesseeName,
        lesseePhone: item.lesseePhone,
        lesseeCardNo: ''
      })
      this.lesseePhone = item.lesseePhone
      this.lesseeId = item.lesseeId
      this.demandId = item.id
      this.touristSourcevisible = false
      this.touristData = item
      this.accendantId = item.accendantId // 签约人id
      this.signName = item.accendantName // 签约人名字
      this.showLesseePhone = item.lesseePhone
      // 商铺类型
      this.getDicts('shop_nature').then((res) => {
        if (res.code === 200) {
          this.shopsTypeList = res.data
        }
      })
      // 投资类型
      this.getDicts('investment_type').then((response) => {
        if (response.code === 200) {
          this.$nextTick(() => {
            this.investmentTypelist = response.data
          })
        }
      })
    },
    // 到列表
    toList () {
      // let route = this.$route
      // sessionStorage.setItem('currentRoute',JSON.stringify(route))
      this.$router.push({ path: '/ContractList' }, (res) => {
        this.routeCallback(res)
        // console.log(this,'this')
      })
    },
    //  新增合同接口
    getAddContract (params) {
      // this.submitLoading = true
      addContract(params)
        .then((res) => {
          this.submitLoading = false
          if (res.code === 200) {
            this.$message.success('新增合同成功')
            this.changeSaveType()
            this.toList()
          }
        })
        .then((res) => {
          this.spinning = false
          if (res.code === 200) {
            this.touristUserList = res.data.records
            this.total = res.data.total
          }
        })
    },
    getEditContract (params) {
      editContractsInfo(params)
        .then((res) => {
          this.submitLoading = false
          if (res.code === 200) {
            this.$message.success('编辑合同成功')
            this.changeSaveType()
            this.toList()
          }
        })
        .then((res) => {
          console.log(res)
          this.spinning = false
          if (res.code === 200) {
            this.touristUserList = res.data.records
            this.total = res.data.total
          }
        })
    },
    // 上传租赁合同
    uploadImgurl (url) {
      this.contractUrl = url
    },
    // 产权文件上传
    uploadPropertyUrl (url) {
      this.propertyUrl = url
    },
    // 出租方文件上传
    uploadLessorCardUrl (url) {
      this.lesseeCardUrl = url
    },
    // 承租方身份证文件
    // uploadLesseeCardUrl (url) {
    //   this.lessorCardUrl = url
    // },
    // 其他
    uploadOtherUrl (url) {
      this.otherUrl = url
    },
    // 获取详情---
    getContractsInfo (id) {
      contractsInfo(id).then((res) => {
        const { code, data } = res
        // console.log(data, '房源详情')
        console.log(code)
        if (code === 200) {
          const pleLIst = data.paymentMethod.split('F')
          this.iscontractYype = data.contractType == 1
          this.id = data.id
          this.houseId = data.houseId // 旧的房源id
          this.accendantId = data.signId
          this.signName = data.signName
          this.hoursInfoVoList = data.contractLessorRelationVoList
          this.hoursInfoVoList.forEach((item) => {
            if (item.lessorsType === '1') {
              item.lable = '业主'
              this.item_lessorsPhone = item.lessorsPhone
            }
            if (item.lessorsType === '2') {
              item.lable = '转让方'
            }
            if (item.lessorsType === '3') {
              item.lable = '二房东'
              this.item_lessorsPhone = item.lessorsPhone
            }
          })
          // console.log('====', data.signDate)
          this.$nextTick(() => {
            console.log(data, 'data')
            this.item_lessorsPhone = this.item_lessorsPhone || data.lessorPhone
            this.form.setFieldsValue({
              lessorName: data.lessorName,
              lessorCardNo: data.lessorCardNo,
              lessorAddress: data.lessorAddress,
              lessorPhone: data.lessorPhone,
              lesseeName: data.lesseeName,
              lesseeCardNo: data.lesseeCardNo,
              lesseeBrandName: data.lesseeBrandName,
              rentExpense: data.rentExpense,
              transferFee: data.transferFee,
              paymentMethod: pleLIst[1],
              pledge: pleLIst[0].replace('Y', ''),
              isRentfreePeriod: data.isRentfreePeriod,
              daysAdvance: data.daysAdvance,
              growthPattern: data.growthPattern,
              leaseStartTime: data.leaseStartTime,
              firstPayDate: data.firstPayDate,
              leaseEndTime: data.leaseEndTime,
              // contractType: data.contractType,
              // signId: data.signId,
              // lesseeComm: data.lesseeComm,
              // houstInfoFee: data.houstInfoFee,
              // customerInfoFee: data.customerInfoFee,
              // signDate: data.signDate,
              contractsRemark: data.contractsRemark,
              rentfreePeriod: data.rentfreePeriod,
              lesseePhone: data.lesseePhone,
              contractCode: data.contractCode
            })
          })
          console.log(data.lesseePhone)
          if (data.contractType) {
            this.isSelectContractType = true
          }
          if (this.iscontractYype) {
            this.form.setFieldsValue({
              contractType: data.contractType,
              lessorComm: data.lessorComm, // 房东佣金lessorComm
              lesseeComm: data.lesseeComm, // 租客佣金lesseeComm
              houstInfoFee: data.houstInfoFee, // 房源方信息费houstInfoFee
              customerInfoFee: data.customerInfoFee, // 客源方信息费customerInfoFee
              signDate: data.signDate
            })
            this.shopName = data.houseInfoVo.shopName
            this.houseCode = data.houseInfoVo.houseCode
            this.showLesseePhone = data.lesseePhone
          } else {
            this.form.setFieldsValue({
              lesseePhone: data.lesseePhone,
              contractType: data.contractType,
              lessorComm: data.lessorComm, // 房东佣金lessorComm
              lesseeComm: data.lesseeComm, // 租客佣金lesseeComm
              houstInfoFee: data.houstInfoFee, // 房源方信息费houstInfoFee
              customerInfoFee: data.customerInfoFee, // 客源方信息费customerInfoFee
              signDate: data.signDate,
              transactionAmount: data.transactionAmount, // 成交金额
              paymentType: data.paymentType // 付款方式
            })
            this.shopName = data.houseInfoSaleVo.shopName
            this.houseCode = data.houseInfoSaleVo.houseCode
            this.showLesseePhone = data.lesseePhone
          }

          if (data.lesseeRequirementVo) {
            this.touristData = data.lesseeRequirementVo
            this.touristData.lesseeName = data.lesseeRequirementVo.lesseeInfoVo.lesseeName
            this.touristData.lesseeCode = data.lesseeRequirementVo.lesseeInfoVo.lesseeCode
            this.lesseeId = data.lesseeRequirementVo.lesseeId
            this.demandId = data.lesseeRequirementVo.id
          }

          if (data.lesseeRequirementSaleVo) {
            this.touristData = data.lesseeRequirementSaleVo
            this.touristData.lesseeName = data.lesseeRequirementSaleVo.lesseeInfoVo.lesseeName
            this.touristData.lesseeCode = data.lesseeRequirementSaleVo.lesseeInfoVo.lesseeCode
            this.lesseeId = data.lesseeRequirementSaleVo.lesseeId
            this.demandId = data.lesseeRequirementSaleVo.id
          }

          if (data.houseInfoVo) {
            this.records[0] = data.houseInfoVo
            this.records[0].lessorIds = data.houseInfoVo.lessorIds.split(',')
            this.records[0].lessorIds = parseFloat(this.records[0].lessorIds[0])
            // 房源联系人信息
            this.records[0].lessorInfoVoList = data.houseInfoVo.lessorInfoVoList
          }

          if (data.houseInfoSaleVo) {
            this.records[0] = data.houseInfoSaleVo
            this.records[0].lessorIds = data.houseInfoSaleVo.lessorIds.split(',')
            this.records[0].lessorIds = parseFloat(this.records[0].lessorIds[0])
            // 房源联系人信息
            this.records[0].lessorInfoVoList = data.houseInfoSaleVo.lessorInfoVoList
          }

          if (data.otherUrlList) {
            this.otherUrl = OSS_BASE_URL + data.otherUrlList[0].fileName
            this.otherUrlOssid = data.otherUrlList[0].ossId
          }
          if (data.lessorCardUrlList) {
            if (data.lessorCardUrlList.length > 0) {
              const obj = this.rebuildPicList(data.lessorCardUrlList)
              console.log(obj, 'obj')
              this.lesseeCardList = obj.resList
              this.lessorCardUrlOssid = obj.ossIdArr

              // this.lessorCardUrlOssid = obj.ossIdArr.toString()
            }
          }
          if (data.lesseeCardUrlList) {
            if (data.lessorCardUrlList.length > 0) {
              const obj = this.rebuildPicList(data.lesseeCardUrlList)
              console.log(obj, 'obj')
              this.LessorCardList = obj.resList
              this.lesseeCardUrlOssid = obj.ossIdArr
              // this.lesseeCardUrlOssid = obj.ossIdArr.toString()
            }
          }
          if (data.contractUrlList) {
            // this.contractUrl = OSS_BASE_URL + data.contractUrlList[0].fileName
            // this.contractUrlOssid = data.contractUrlList[0].ossId

            this.contractUrlOssid = data.contractUrl
            this.contractFileList = data.contractUrlList.map((el) => ({
              uid: '-' + el.ossId,
              name: el.fileName,
              status: 'done',
              url: OSS_BASE_URL + el.fileName,
              ossId: el.ossId
            }))
          }
          if (data.propertyUrlList) {
            // this.propertyUrl = OSS_BASE_URL + data.propertyUrlList[0].fileName
            // this.propertyUrlOssid = data.propertyUrlList[0].ossId

            this.propertyUrlOssid = data.propertyUrl
            this.propertyFileList = data.propertyUrlList.map((el) => ({
              uid: '-' + el.ossId,
              name: el.fileName,
              status: 'done',
              url: OSS_BASE_URL + el.fileName,
              ossId: el.ossId
            }))
          }
        }
      })
    },

    rebuildPicList (list) {
      const obj = {}
      const resList = []
      let fileObj = {}
      const ossIdArr = []
      if (list != null && list.length > 0) {
        for (const item of list) {
          fileObj = {}
          fileObj.uid = item.ossId
          fileObj.name = item.fileName
          fileObj.status = 'done'
          fileObj.url = process.env.VUE_APP_OSS_URL + item.fileName
          fileObj.response = { code: 200, msg: '操作成功', data: { ossId: item.ossId } }
          resList.push(fileObj)
          ossIdArr.push(fileObj.uid)
        }
        obj.resList = resList
        obj.ossIdArr = ossIdArr
      }
      return obj
    },
    uploadImgOssId (id) {
      this.contractUrlOssid = id
    },
    uploadPropertyUrlOssId (id) {
      this.propertyUrlOssid = id
    },
    uploadOtherUrlOssId (id) {
      this.otherUrlOssid = id
    },
    // 生成合同代码
    generateCode () {
      let years = ''
      let dateTime = ''
      years = this.$moment().subtract(1, 'days').format('YYYY')
      dateTime = this.$moment().format('YYYY-MM-DD HH:mm:ss')
      dateTime = this.$moment().valueOf(dateTime)
      const code = years + dateTime + 'CD'
      this.form.setFieldsValue({
        contractCode: code
      })
    },
    // 上传多张甲方身份证图片
    ManyLessorCard (e) {
      console.log(e, 'ee')
      const manyCard = []
      e.forEach((item) => {
        if (item.response) {
          manyCard.push(item.response.data.ossId)
        }
      })
      this.lesseeCardUrlOssid = manyCard
      console.log(manyCard, manyCard)
    },
    // 上传多张乙方身份证图片
    ManyLesseeCardUrl (e) {
      console.log(e, 'ee')
      const manyCard = []
      e.forEach((item) => {
        if (item.response) {
          manyCard.push(item.response.data.ossId)
        }
      })
      this.lessorCardUrlOssid = manyCard
    }
  },
  activated () {
    const storage = sessionStorage.getItem('history')
    let data = {}
    if (storage) {
      data = JSON.parse(storage)
      if (data.fromPage === 'add') {
        this.form.resetFields()
        this.contractFileList = []
        this.propertyFileList = []
        this.LessorCardList = []
        this.lesseeCardList = []
        this.otherUrl = ''
        this.isSelectContractType = null
      }
    }
    if (!this.$route.query.id) {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          signDate: this.$moment(getCurrentDate()).format('YYYY-MM-DD')
        })
      })
    }

    this.init()
  },
  created () {
    this.init()
    console.log(this.getDisabled, 'getDisabled')
    // 客源需求状态
    // this.getDicts('house_status').then((response) => {})
  },
  deactivated () {
    sessionStorage.removeItem('history')
  },
  watch: {
    iscontractYype: {
      handler (enw, old) {
        console.log()
      }
    },
    deep: true
  }
}
</script>
<style lang="less" scoped>
.add-contract {
  height: 100%;
  background-color: #fff;
  padding: 20px;

  .add-title {
    display: flex;
    cursor: pointer;
    // justify-content: space-between;
    h1 {
      font-size: 22px;
      font-weight: 700;
    }

    button {
      width: 100px;
      height: 40px;
    }
  }

  .input-box {
    padding: 0 60px;

    h1 {
      font-size: 16px;
      font-weight: 600;
      padding-bottom: 20px;
    }

    .choice-houses {
      h1 {
        padding: 0;
        font-size: 14px;
        font-weight: 600;
        font-weight: normal;
      }

      p {
        padding: 0;
        color: var(--ThemeColor);
        font-weight: 700;
        cursor: pointer;
      }

      .houses-list {
        background-color: #f9f7fb;
        padding: 20px 0;
        height: 170px;
        border-radius: 15px;
      }

      .tenant-box {
        display: flex;

        .ant-form-item {
          margin-right: 60px;
          padding-top: 20px;
          width: 200px;
        }

        .lable-box {
          font-size: 14px;
          font-weight: normal;
          display: flex;

          span:first-child {
            color: red;
            padding-top: 3px;
            padding-right: 4px;
            display: inline-block;
          }

          span:last-child {
            color: #222222;
          }
        }
      }

      /deep/ .content .menudetail[data-v-f61602e6] {
        margin: 0;
      }

      /deep/ .ant-col-2 {
        display: none;
      }

      /deep/ .content .menudetail[data-v-f61602e6] {
        justify-content: space-between;
      }

      /deep/ .content .menudetail[data-v-f61602e6] {
        border: none;
      }
    }

    .transaction-box {
      .transaction-msg {
        display: flex;

        .ant-select {
          width: 200px;
        }

        .ant-form-item {
          margin-right: 60px;
        }
      }

      .payment-box {
        display: flex;
        flex-wrap: wrap;

        /deep/ .ant-form-item-control {
          width: 200px;
        }
      }

      .ant-form-vertical .ant-form-item-control {
        line-height: 1.5;
        display: flex;
        flex-direction: column;
      }
    }

    .textarea {
      width: 80%;
    }

    .enclosure {
      .contract-upload {
        padding: 20px 0;

        p {
          font-weight: 700;
          color: #000;
        }
      }
    }
  }
}
.choice-housesdilog {
  height: 600px;
}
.ant-spin-nested-loading {
  height: 500px;
}

// 选择房源样式
/deep/ .ant-modal-content {
  padding: 10px 40px;
}

/deep/ .ant-modal-header,
/deep/ .ant-modal-footer {
  border: none !important;
}

/deep/ .ant-modal-header {
  text-align: center;
}

// 选择客源弹窗样式
.tourist-item {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  .user-name {
    display: flex;
    flex: 6;
    > h1 {
      width: 80px;
      height: 80px;
      background-color: #fbc8cb;
      text-align: center;
      line-height: 80px;
      font-size: 24px;
      color: #fff;
      margin-right: 20px;
    }

    .user-msg {
      height: 1px;

      div {
        display: flex;
        align-items: center;

        h1 {
          font-size: 20px;
          font-weight: 700;
        }

        span {
          padding: 0px 16px;
          border: 1px solid #f6bdbf;
          font-size: 12px;
          height: 20px;
          color: #f6bdbf;
          margin: 0 6px 8px 6px;
          display: inline-block;
          background-color: #feeeee;
          border-radius: 4px;
        }
      }

      p {
        font-size: 12px;
        color: #000;
        font-weight: 600;
        line-height: 12px;
      }
    }
  }

  p {
    flex: 2;
    font-size: 12px;
  }
}

.contract-code {
  display: flex;
  /deep/ .ant-form-item-children {
    display: flex;
  }
}

.contract-code {
  display: flex;
  /deep/ .ant-form-item-children {
    display: flex;
  }
}

.tips {
  color: #f5222d !important;
  font-size: 12px;
  font-weight: normal;
}

.house-form-box {
  /deep/ .ant-form-item {
    margin-right: 20px !important;
  }
}
</style>
